import React, { Component } from 'react';
import {
  TABLE,
  KEYEDLAYOUT,
  CARDLAYOUT,
  ACCORDIANLAYOUT,
  WORKFLOWCARDLAYOUT,
  IMAGECARDLAYOUT,
} from '../../elements/index';
import ReadAllHeader from './headers/ReadAllHeader';
import Filters from './filters/index';
import { Alert, Label } from 'reactstrap';
import sizeMe from 'react-sizeme';
import PropTypes from 'prop-types';
import DataListStore from './filters/DataListStore';
import DataListWrapper from './filters/DataListWrapper';
import queryString from 'query-string';
import LoaderComponents from './LoaderComponents';

class ReadAll extends Component {
  constructor(props) {
    super(props);
    this._dataList = new DataListStore(0);
    const params = queryString.parse(window.location.search);
    this.state = {
      filteredDataList: this._dataList,
      additionalModelData: props.workflowData && props.workflowData.__ADDITIONAL_MODEL_DATA ? props.workflowData.__ADDITIONAL_MODEL_DATA : null,
      sorting: {
        classProperty: null,
        order: '',
      },
      querySearch: params['qs'],
      allData: []
    };
  }
  componentDidMount() {
    const { columnLayoutModel } = this.props;
    this.setState({
      sorting: {
        classProperty: this.props.sortPagination.sortField,
        order: this.props.sortPagination.order,
      },
    });
    if (!columnLayoutModel) { }
    this.triggerReadAll(null, null, this.props);
  }
  toggleTriggerReadAllComponent(nextProps) {
    const { workflow, collection, sortPagination, columnLayoutModel, colModelId, containerIndex, workflowItem, loadReadAll, reloadTimeData, container, toggleIsTimer, isReloadTimer } = nextProps;
    const { sorting } = this.state;
    const cid = 'c'+containerIndex;
    let counter = window[workflow.sessionId + (containerIndex?cid:'')];

    if (loadReadAll || !collection && typeof collection == 'object' && !columnLayoutModel && !window[`typmodelid`] != workflowItem.typeModel.id) {
      this.triggerReadAll(null, workflowItem, nextProps);
    }
    
    if(columnLayoutModel && colModelId && !counter || (loadReadAll || !collection && counter < 2)){
      window[workflow.sessionId + (containerIndex?cid:'')] = typeof colModelId == 'number' && (typeof counter != 'undefined' || counter != null)  ? counter + 1 : 0;
      this.triggerReadAll(colModelId, null, nextProps);
    }
    // if (columnLayoutModel && colModelId && !window[`${colModelId}_${containerIndex}`] || (loadReadAll || !collection && window[`${colModelId}_${containerIndex}`])) {
    //   window[`${colModelId}_${containerIndex}`] = 1
    //   this.triggerReadAll(colModelId, null, nextProps);
    // }
    if (colModelId && `${workflowItem.uniqueCode}-${containerIndex}-end` == global.wfItemContainer) {
      global.wfItemContainer = null
      this.triggerReadAll(colModelId, null, nextProps);
    }
    if ((global.tidTriggered && global.tidTriggerEnd && global.tidTriggered != global.tidTriggerEnd) && colModelId && !counter) {
      //window[`${colModelId}_${containerIndex}`] = 1
      this.triggerReadAll(colModelId, null, nextProps);
      if ((global.triggeredId && global.triggeredId.indexOf(colModelId) !== -1) && (global.cIndex && global.cIndex !== containerIndex)) {
        global.tidTriggered = null;
        global.triggeredId = null;
        global.cIndex = null;
      } else {
        global.triggeredId = global.triggeredId + '/' + colModelId;
        global.cIndex = containerIndex;
      }
    } else if ((global.tidTriggered && global.tidTriggerEnd && global.tidTriggered != global.tidTriggerEnd) && colModelId && counter == 2) {
      window[workflow.sessionId + (containerIndex?cid:'')] = null
    }
    if (sorting.classProperty != null) {
      this.triggerReadAll(null, null, nextProps);
    }
    if (
      collection &&
      Array.isArray(collection.data) &&
      this.state.filteredDataList.length !== collection.data.length
    ) {
      this._dataList = new DataListStore(collection.data);
      this.setState({ filteredDataList: this._dataList });
    }
  }
  extractConnectorRuleProperties = (actions) => {
    let propertyArray = [];

    for (let i = 0; i < actions.length; i++) {
      let action = actions[i];
      let connector = action.connector || {};
      let rules = connector.rules || [];

      for (let j = 0; j < rules.length; j++) {
        let rule = rules[j];

        let keyProperty = rule && rule.key && rule.key.property;
        let valueProperty = rule && rule.value && rule.value.property;

        if (keyProperty && propertyArray.indexOf(keyProperty) === -1) {
          propertyArray.push(keyProperty);
        }

        if (valueProperty && propertyArray.indexOf(valueProperty) === -1) {
          propertyArray.push(valueProperty);
        }
      }
    }

    return propertyArray;
  };
  startTimerLoop = () => {
    const { minutes, seconds } = this.state.timerConfig;

    const interval = setInterval(() => {
      let { minutes, seconds } = this.state.timerConfig;

      if (seconds > 0) {
        seconds--;
      }
      else if (minutes > 0) {
        minutes--;
        seconds = 59;
      }
      else {
        minutes = 0;
        seconds = 5;
      }

      this.setState({
        timerConfig: { minutes, seconds }
      });

    }, 1000);

    this.setState({ interval });

  }
  componentWillReceiveProps(nextProps) {
    const { collection, sortPagination, columnLayoutModel, colModelId, containerIndex, workflowItem, loadReadAll, reloadTimeData, container, toggleIsTimer, isReloadTimer } = nextProps;
    const { sorting } = this.state;
    let condition

    if (reloadTimeData &&
      reloadTimeData.refreshSpecificContainer &&
      reloadTimeData.specificContainer &&
      reloadTimeData.specificContainer.length) {
      const findingCont = reloadTimeData.specificContainer.filter((a, i) => a.label === container.displayText)
      condition =
        container && container.displayText && findingCont && findingCont.length && findingCont[0].label &&
        container.displayText === findingCont[0].label;

    }



    if (condition && isReloadTimer) {
      if (colModelId) {
        this.triggerReadAll(colModelId, null, nextProps);
      }
      else {
        this.triggerReadAll(null, null, nextProps);
      }


      this.props.toggleIsTimer(false);
      // console.log(`props in will recieve 1`, nextProps)
    }
    else {
      this.toggleTriggerReadAllComponent(nextProps)
      // console.log(`props in will recieve 2`, nextProps)
    }


  };

  triggerReadAll(colModelId, wftem, props) {
    const {
      workflowItem,
      workflow,
      isBase,
      pagination,
      paginationStart,
      pageSize,
      filterMap,
      sortPagination,
      containerIndex,
      container,
      columnIndex,
      targetContainerIndex,
      getInlineActions
    } = props;
    const { sorting } = this.state;
    const {
      layoutProperties: { readAllFilterConfig, aggregateConfig, readAllViews, disbableOptimize }
    } = workflowItem;
    const fetchAfterFilter =
      readAllFilterConfig &&
      readAllFilterConfig[containerIndex] &&
      readAllFilterConfig[containerIndex].filterConfig &&
      readAllFilterConfig[containerIndex].filterConfig.fetchAfterFilter;
    const allDataDownload = container.properties.allDataDownload;
    const alternateTypeModel = container.properties.alternateTypeModel;
    const columnLayoutModel =
      container.properties.colLayoutConfig &&
      container.properties.colLayoutConfig[`columnLayoutModel-${columnIndex}`];
    const wf = Object.assign({}, workflow);
    wf['collections'] = null;
    const aggregates =
      aggregateConfig &&
      aggregateConfig[containerIndex] &&
      aggregateConfig[containerIndex].aggregateFieldsConfig &&
      aggregateConfig[containerIndex].aggregateFieldsConfig.aggregates;
    let tableConfig = readAllViews[`${containerIndex}_${columnIndex}`] && readAllViews[`${containerIndex}_${columnIndex}`].table && readAllViews[`${containerIndex}_${columnIndex}`].table;
    if (!tableConfig) {
      tableConfig = readAllViews[containerIndex] && readAllViews[containerIndex].table;
    }
    let recieveFields = [];
    if (tableConfig && tableConfig.isConfigured && tableConfig.config) {
      const tableColumns = tableConfig.config.columns;
      Array.isArray(tableColumns) && tableColumns.map(column => {
        if (column.config && column.config.flyoutField) {
          const expression = new RegExp(/\{\{(.*?)\}\}/g);
          const val = column.config.flyoutField.replace(expression, (pattr, matched) => {
            const columnKey = column.field.classProperty;
            if (column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")) {

              const base = columnKey.replace(/[{}]/g, '');       // "funder"
              const prop = matched.replace(/[{}]/g, '');         // "fundername"
              const result = `${base}.${prop}`;              // "{{funder.fundername}}"

              recieveFields.push(result);
            } else {

              recieveFields.push(matched);
            }
          })
        } else if (column.config && column.config.modelSelector) {

          const expression = new RegExp(/\{\{(.*?)\}\}/g);
          const val = column.config.modelSelector.replace(expression, (pattr, matched) => {
            const columnKey = column.field.classProperty;
            if (column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")) {

              const base = columnKey.replace(/[{}]/g, '');       // "funder"
              const prop = matched.replace(/[{}]/g, '');         // "fundername"
              const result = `${base}.${prop}`;              // "{{funder.fundername}}"

              recieveFields.push(result);
            } else {

              recieveFields.push(matched);
            }

          })
        } else {

          recieveFields.push(column.field.classProperty)
        }
      })
    }
    const allActions = getInlineActions(workflowItem, targetContainerIndex);
    const menuTypeInlineActionOnly = allActions.inlines
    const extractedAllProperties = this.extractConnectorRuleProperties(menuTypeInlineActionOnly)
    recieveFields.push(...extractedAllProperties);


    // This is to remove [] format if anything is there
    const cleanedFields = recieveFields.map(field => {
      const bracketIndex = field.indexOf('[');
      if (bracketIndex !== -1) {
        return field.substring(0, bracketIndex);
      }
      return field;
    });

    recieveFields = cleanedFields
    let payload = {
      customModelName: columnLayoutModel ? columnLayoutModel.name : alternateTypeModel
        ? alternateTypeModel.name : wftem ? wftem.typeModel.name : workflowItem.typeModel.name,
      typeId: colModelId
        ? colModelId
        : alternateTypeModel
          ? alternateTypeModel.id
          : wftem ? wftem.typeModel.id : workflowItem.typeModel.id,
      customerName: workflowItem.typeModel.customerName,
      workflow: {
        id: wf.id,
        displayMode: wf.displayMode,
        workflowSession: wf.sessionId
      },
      isBase,
    };

    if (recieveFields && !disbableOptimize) {
      const tempFields = Object.assign([], recieveFields);
      recieveFields = tempFields.filter((value, index, array) => {
        return array.indexOf(value) === index;
      })
      if (recieveFields.length) {
        payload['recieveFields'] = recieveFields;
      }
    }
    if (aggregates && aggregates.length > 0) {
      payload.aggregates = aggregates;
    }
    if (pagination) {
      payload.count = pageSize;
      payload.start = paginationStart;
      payload.filters = [];
    }
    if (sorting.classProperty != null) {
      payload.sort = [];
      payload.sort.push({
        sortField: sorting.classProperty,
        descending: sorting.order == 'DESCENDING' ? true : false,
      });
      if (Object.keys(filterMap).length) {
        for (let filterKey in filterMap) {
          const _f = filterMap[filterKey];
          const { collection, targetClassProperty, filterBy, leafType } = _f;
          if (collection === true) {
            let modelName = targetClassProperty;
            let modelProperty = targetClassProperty;
            if (targetClassProperty.indexOf('.') !== -1) {
              const splits = targetClassProperty.split('.');
              modelName = splits.shift();
              modelProperty = splits.join('.');
            }
            payload.filterInAnotherModel = {
              modelName,
              modelProperty,
            };
          } else {
            payload.filters.push({
              filterField: targetClassProperty,
              filterValue:
                filterBy && filterBy.length && filterBy[0] == 'NULL'
                  ? null
                  : filterBy,
              valueType: leafType,
            });
          }
        }
      }
    }
    if (this.state.querySearch) {
      if (!payload.filters) payload.filters = [];
      payload.filters.push({
        filterField: '*',
        filterValue: [this.state.querySearch],
        isSearch: true,
      });
    }
    if (!fetchAfterFilter || this.state.querySearch) {
      const currentUrl = window.location.href;
      const urlFilterValue = this.extractCtValues(currentUrl);
      if (columnLayoutModel) {
        if (colModelId || alternateTypeModel) {
          if (!urlFilterValue) {
            this.props.readAll(payload);
          }

        }
      } else {
        if (!urlFilterValue) {
          this.props.readAll(payload);
        }
      }
      this.setState({
        sorting: {
          classProperty: null,
          order: '',
        },
      });
      if (allDataDownload) {
        payload.count = '';
        const self = this;
        this.props.readAllData(payload).then(res => {
          self.setState({
            allData: res.data,
          });
        });
      }
    }
  }

  extractCtValues = (url) => {
    try {
      const parsedUrl = new URL(url);
      const ctValue = parsedUrl.searchParams.get('ct');

      if (!ctValue) return null;
      const [field, value] = ctValue.split(':');

      return { field, value };
    } catch (err) {
      return null;
    }
  };

  sortByClassProperty = classProperty => {
    const { sortPagination } = this.props;
    let order = sortPagination.order;
    if (sortPagination.sortField === classProperty) {
      if (order === 'ASCENDING') {
        order = 'DESCENDING';
      } else {
        order = 'ASCENDING';
      }
    } else {
      order = 'DESCENDING';
    }
    this.setState({
      sorting: {
        classProperty,
        order,
      },
    });
    sortPagination.order = order;
    sortPagination.sortField = classProperty;
    this.props.setSortAndPagination(sortPagination);
  };

  getMenuTypeInlineAction = actions => {
    const menuTypeAction = [];
    actions.length &&
      actions.map((action, index) => {
        if (
          action.actionProperties &&
          action.actionProperties.elementType == 'MENULINK'
        ) {
          menuTypeAction.push(action);
        }
      });
    return menuTypeAction;
  };

  componentWillUnmount() {
    const {
      workflowItem,
      workflow,
      isBase,
      pagination,
      paginationStart,
      pageSize,
      filterMap,
      sortPagination,
      containerIndex,
      container,
      columnIndex,
      targetContainerIndex,
      getInlineActions,
      workflowItem: {
        layoutProperties: {
          readAllFilterConfig
        }
      }
    } = this.props;
    if (readAllFilterConfig && readAllFilterConfig[containerIndex] && readAllFilterConfig[containerIndex].filterConfig && readAllFilterConfig[containerIndex].filterConfig.showLoadingTransition) {
      const wf = Object.assign({}, workflow);
      const columnLayoutModel =
        container.properties.colLayoutConfig &&
        container.properties.colLayoutConfig[`columnLayoutModel-${columnIndex}`];
      const alternateTypeModel = container.properties.alternateTypeModel;
      let payload = {
        customModelName: columnLayoutModel ? columnLayoutModel.name : alternateTypeModel
          ? alternateTypeModel.name : workflowItem.typeModel.name,
        typeId: alternateTypeModel
          ? alternateTypeModel.id
          : workflowItem.typeModel.id,
        customerName: workflowItem.typeModel.customerName,
        workflow: {
          id: wf.id,
          displayMode: wf.displayMode,
          workflowSession: wf.sessionId
        },
        isBase,
        containerId: containerIndex
      };
      this.props.clearReadAllCollection(payload)
    }
  }

  render() {
    const {
      getInlineActions,
      collection,
      workflowItem,
      workflowId,
      workflow,
      updatePayload,
      save,
      size,
      saveResponse,
      triggerAction,
      user,
      containerIndex,
      companyDetails,
      targetContainerIndex,
      container,
      columnIndex,
      typeModelId,
      workflowData,
      filterTemplate,
      filterPlacement,
      filterTemplateCompany,
      workflowItem: {
        layoutProperties: {
          readAllFilterConfig
        }
      }
    } = this.props;
    let { viewMode } = this.props;
    
    const loaderUrl =
      this.props.companyDetails &&
        this.props.companyDetails.data &&
        this.props.companyDetails.data.loaderURL
        ? this.props.companyDetails.data.loaderURL
        : null;

    const loaderTemplate =
      this.props.companyDetails &&
        this.props.companyDetails.data &&
        this.props.companyDetails.data.companySettings && this.props.companyDetails.data.companySettings.loaderTemplate
        ? this.props.companyDetails.data.companySettings.loaderTemplate
        : null;


    const { table, card, keyed, accordian, workflowCard, imageCard } =
      workflowItem.layoutProperties.readAllViews[`${containerIndex}_${columnIndex}`] ||
      workflowItem.layoutProperties.readAllViews[containerIndex | ''] ||
      workflowItem.layoutProperties.readAllViews;

      if(viewMode =="TABLE" && table && !table.isConfigured){
          viewMode=null
      }
    if (card && card.isConfigured && !viewMode) viewMode = 'CARD';
    if (keyed && keyed.isConfigured && !viewMode) viewMode = 'KEYED';
    if (accordian && accordian.isConfigured && !viewMode) viewMode = 'ACCORDIAN';
    if (workflowCard && workflowCard.isConfigured && !viewMode) viewMode = 'WORKFLOWCARD';
    if (imageCard && imageCard.isConfigured && !viewMode) viewMode = 'IMAGECARD';
    if (table && table.isConfigured && !viewMode) viewMode = 'TABLE';
    if (!collection && (readAllFilterConfig && readAllFilterConfig[containerIndex] && readAllFilterConfig[containerIndex].filterConfig && readAllFilterConfig[containerIndex].filterConfig.showLoadingTransition)) {
      return (
        <div>
          {loaderTemplate === 'skeleton' ?
            <LoaderComponents /> :
            !loaderUrl ? (
              <div className='loader-container'>
                <span className='loader_3'></span>
              </div>
            ) : (
              <div className='preloader d-flex align-items-center justify-content-center flex-column'>
                <img width='400px' height='238px' src={loaderUrl}></img>
              </div>
            )}
        </div>
      );
    }
    if (!collection) return null;
    if (collection.isLoading && viewMode !== 'KEYED')
      return (
        <div>
          {loaderTemplate === 'skeleton' ?
            <LoaderComponents /> :
            !loaderUrl ? (
              <div className='loader-container'>
                <span className='loader_3'></span>
              </div>
            ) : (
              <div className='preloader d-flex align-items-center justify-content-center flex-column'>
                <img width='400px' height='238px' src={loaderUrl}></img>
              </div>
            )}
        </div>
      );
    let dateformat =
      companyDetails && companyDetails.data && companyDetails.data != null
        ? companyDetails.data.companySettings.dateformat
        : '';
    dateformat = dateformat ? dateformat.toUpperCase() : '';
    const { layoutProperties } = workflowItem;
    let noDataText =
      layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex]
        ? layoutProperties.readAllFilterConfig[containerIndex] &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig
          .noDataText
        : layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig.noDataText;

    let noDataTextHeading =
      layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex]
        ? layoutProperties.readAllFilterConfig[containerIndex] &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig
          .noDataTextHeading
        : layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig.noDataTextHeading;

    let templateType =
      layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex]
        ? layoutProperties.readAllFilterConfig[containerIndex] &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig
          .templateType
        : layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig.templateType;

    let filterNoDatamage =
      layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex]
        ? layoutProperties.readAllFilterConfig[containerIndex] &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig
          .filterNoDatamage
        : layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig.filterNoDatamage;
    const menuItemIconPosition = layoutProperties.menuItemIconPosition;
    const menuItemIcon = layoutProperties.menuItemIcon;
    const { filteredDataList, sorting, allData } = this.state;

    const columns = table && table.isConfigured && table.config.columns;
    let selectedTemplate = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.tableTemplate
      ? companyDetails.data.companySettings.tableTemplate : table && table.isConfigured && table.selectedTemplate;

    if (table && table.isConfigured && table.selectedTemplate) {
      selectedTemplate = table && table.isConfigured && table.selectedTemplate
    }

    const tableStyleConfig = table && table.config && table.config.tableStyleConfig;

    const showThumnailImage = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.showThumnailImage;
    const thmbnailFormatSelection = companyDetails && companyDetails.data != null && companyDetails.data.companySettings && companyDetails.data.companySettings.thmbnailFormatSelection;


    const cardConfig = card && card.config;
    const keyedConfig = keyed && keyed.config;
    const accordianConfig = accordian && accordian.config;
    const workflowCardConfig = workflowCard && workflowCard.config;
    const imageCardConfig = imageCard && imageCard.config;
    const canActOnMultipleItems = workflowItem.hasOwnProperty(
      'canActOnMultipleItems'
    )
      ? workflowItem.canActOnMultipleItems
      : false;
    if (
      (!table || !table.isConfigured) &&
      (!card || !card.isConfigured) &&
      (!keyed || !keyed.isConfigured) &&
      (!accordian || !accordian.isConfigured) &&
      (!workflowCard || !workflowCard.isConfigured) &&
      (!imageCard || !imageCard.isConfigured)
    )
      return (
        <Alert color='warning'>
          Looks like no layout has not been configured. Please contact the admin
          and configure atleast one layout for this workflow.
        </Alert>
      );
    const actions = getInlineActions(workflowItem, targetContainerIndex);
    const menuTypeInlineAction = this.getMenuTypeInlineAction(actions.inlines);
    const allDataDownload = container.properties.allDataDownload;
    const aggregateConfig = layoutProperties.aggregateConfig;
    const aggregates =
      aggregateConfig &&
      aggregateConfig[containerIndex] &&
      aggregateConfig[containerIndex].aggregateFieldsConfig &&
      aggregateConfig[containerIndex].aggregateFieldsConfig.aggregates;
    const aggregateResp = collection && collection.aggregateResp;
    const aggregateRespKeys = aggregateResp ? Object.keys(aggregateResp) : [];

    const titleReadAllConatinerUI = this.props.container && this.props.container.properties && this.props.container.properties.title
     const showCount = this.props.container && this.props.container.properties && this.props.container.properties.showTotalCount
     const TotalData = collection && collection.data && collection.data.length

    let localSearch =
      layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex]
        ? layoutProperties.readAllFilterConfig[containerIndex] &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig &&
        layoutProperties.readAllFilterConfig[containerIndex].filterConfig
          .localSearch
        : layoutProperties.readAllFilterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig &&
        layoutProperties.readAllFilterConfig.filterConfig.localSearch;
    const rowRule = viewMode === 'TABLE' ? workflowItem.layoutProperties.readAllViews[`${containerIndex}_${columnIndex}`] ?
     workflowItem.layoutProperties.readAllViews[`${containerIndex}_${columnIndex}`].table &&
      workflowItem.layoutProperties.readAllViews[`${containerIndex}_${columnIndex}`].table.config && workflowItem.layoutProperties.readAllViews[`${containerIndex}_${columnIndex}`].table.config.rules :
      workflowItem.layoutProperties.readAllViews[containerIndex] ? workflowItem.layoutProperties.readAllViews[containerIndex].table.config.rules
        : [] : []

    return (
      <div>
        <div className='wf-item-body'>
   {titleReadAllConatinerUI && (
 <div className="readall-container-title">
  {titleReadAllConatinerUI} {showCount  &&<span className="readall-count">{TotalData}</span>}
</div>
)}
          <div className='aggregare-div d-flex justify-content-start'>
            {
              aggregates && aggregates.map((item, i) => {
                let name = item.displayText;
                const valueType = item.valueType
                if (name) {
                  name = 'agg-' + name.toLowerCase().replace(' ', '-');
                  const f = aggregateRespKeys.find(k => k == name);
                  let value = '';
                  if (f) {
                    value = parseFloat(aggregateResp[f])
                    if (valueType == 'ROUNDOFF') {
                      value = Math.round(value);
                    } else if (valueType == 'DECIMAL') {
                      value = value.toFixed(2)
                    }
                    return <div key={i} className='aggregare-item mr-2 mb-1'>
                      <Label for={name} className='text-capitalize mb-1'>{item.displayText}</Label>
                      <div className='p-2' style={{ border: '1px solid #ccc', borderRadius: 2 }}>{value}</div>
                    </div>
                  }
                }
              })
            }
          </div>
          {viewMode === 'TABLE' ? (
            <TABLE
              size={size}
              workflow={workflow}
              workflowId={workflowId}
              rows={filteredDataList}
              columns={columns}
              inlineActions={actions.inlines}
              canActOnMultipleItems={canActOnMultipleItems}
              noDataText={noDataText}
              noDataTextHeading={noDataTextHeading}
              templateType={templateType}
              filterNoDatamage={filterNoDatamage}
              user={user}
              selectedTemplate={selectedTemplate}
              showThumnailImage={selectedTemplate}
              thmbnailFormatSelection={thmbnailFormatSelection}
              tableStyleConfig={tableStyleConfig}
              dateformat={dateformat}
              sortByClassProperty={this.sortByClassProperty}
              sorting={sorting}
              menuTypeInlineAction={menuTypeInlineAction}
              allData={allData}
              allDataDownload={allDataDownload}
              pageSize={this.props.pageSize}
              companyDetails={companyDetails}
              typeModelId={typeModelId}
              columnIndex={columnIndex}
              containerIndex={this.props.containerIndex}
              localSearch={localSearch}
              filterTemplate={filterTemplate}
              filterTemplateCompany={filterTemplateCompany}
              filterPlacement={filterPlacement}
              workflowItem={this.props.workflowItem}
              filterMap={this.props.filterMap}
              onFiltersApplied={this.props.onFiltersApplied}
              onFilterChange={this.props.onFilterChange}
              colModelId={this.props.colModelId}
              filterStateMap={this.props.filterStateMap}
              onClearAppliedFilters={this.props.onClearAppliedFilters}
              rowRule={rowRule}
            />
          ) : (
            ''
          )}
          {viewMode === 'CARD' ? (
            <CARDLAYOUT
              size={size}
              workflow={workflow}
              workflowId={workflowId}
              cards={filteredDataList}
              inlineActions={actions.inlines}
              cardConfig={cardConfig}
              canActOnMultipleItems={canActOnMultipleItems}
              noDataText={noDataText}
              noDataTextHeading={noDataTextHeading}
              templateType={templateType}
              filterNoDatamage={filterNoDatamage}
              containerIndex={containerIndex}
              user={user}
              dateformat={dateformat}
              menuTypeInlineAction={menuTypeInlineAction}
              menuItemIconPosition={menuItemIconPosition}
              menuItemIcon={menuItemIcon}
              allData={allData}
              triggerAction={triggerAction}
              allDataDownload={allDataDownload}
            />
          ) : (
            ''
          )}
          {/* {
  console.log("in HTML", filteredDataList)
} */}

          {viewMode === 'IMAGECARD' ? (
            <IMAGECARDLAYOUT
              size={size}
              workflow={workflow}
              workflowId={workflowId}
              cards={filteredDataList}
              inlineActions={actions.inlines}
              cardConfig={imageCardConfig}
              canActOnMultipleItems={canActOnMultipleItems}
              noDataText={noDataText}
              noDataTextHeading={noDataTextHeading}
              templateType={templateType}
              filterNoDatamage={filterNoDatamage}
              containerIndex={containerIndex}
              user={user}
              dateformat={dateformat}
              menuTypeInlineAction={menuTypeInlineAction}
              menuItemIconPosition={menuItemIconPosition}
              menuItemIcon={menuItemIcon}
              allData={allData}
              triggerAction={triggerAction}
              allDataDownload={allDataDownload}
            />
          ) : (
            ''
          )}
          {viewMode === 'KEYED' ? (
            <KEYEDLAYOUT
              size={size}
              workflow={workflow}
              workflowId={workflowId}
              data={collection.data}
              config={keyedConfig}
              updatePayload={updatePayload}
              save={save}
              saveResponse={saveResponse}
              canActOnMultipleItems={canActOnMultipleItems}
              triggerAction={triggerAction}
              user={user}
              noDataText={noDataText}
              noDataTextHeading={noDataTextHeading}
              templateType={templateType}
              filterNoDatamage={filterNoDatamage}
              dateformat={dateformat}
              {...this.props}
            />
          ) : (
            ''
          )}
          {viewMode === 'ACCORDIAN' ? (
            <ACCORDIANLAYOUT
              size={size}
              workflow={workflow}
              workflowId={workflowId}
              accordians={collection.data}
              accordianConfig={accordianConfig}
              updatePayload={updatePayload}
              save={save}
              saveResponse={saveResponse}
              canActOnMultipleItems={canActOnMultipleItems}
              triggerAction={triggerAction}
              noDataText={noDataText}
              noDataTextHeading={noDataTextHeading}
              templateType={templateType}
              filterNoDatamage={filterNoDatamage}
              dateformat={dateformat}
              user={user}
            />
          ) : (
            ''
          )}
          {viewMode === 'WORKFLOWCARD' ? (
            <WORKFLOWCARDLAYOUT
              additionalModelData={this.state.additionalModelData}
              allWorkflowData={workflowData}
              size={size}
              workflow={workflow}
              workflowId={workflowId}
              workflowCards={collection.data}
              workflowCardConfig={workflowCardConfig}
              updatePayload={updatePayload}
              save={save}
              saveResponse={saveResponse}
              columnIndex={columnIndex}
              containerIndex={this.props.containerIndex}
              canActOnMultipleItems={canActOnMultipleItems}
              triggerAction={triggerAction}
              inlineActions={actions.inlines}
              noDataText={noDataText}
              noDataTextHeading={noDataTextHeading}
              templateType={templateType}
              filterNoDatamage={filterNoDatamage}
              dateformat={dateformat}
              user={user}
              menuTypeInlineAction={menuTypeInlineAction}
              menuItemIconPosition={menuItemIconPosition}
              menuItemIcon={menuItemIcon}
              allData={allData}
              allDataDownload={allDataDownload}
              onHandleSubmit={this.props.onHandleSubmit}
              localSearch={localSearch}
              filterTemplate={filterTemplate}
              filterTemplateCompany={filterTemplateCompany}
              filterPlacement={filterPlacement}
              companyDetails={companyDetails}
              workflowItem={this.props.workflowItem}
              filterMap={this.props.filterMap}
              onFiltersApplied={this.props.onFiltersApplied}
              onFilterChange={this.props.onFilterChange}
              colModelId={this.props.colModelId}
              filterStateMap={this.props.filterStateMap}
              onClearAppliedFilters={this.props.onClearAppliedFilters}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

ReadAll.defaultProps = {
  viewMode: null,
};

ReadAll.propTypes = {
  viewMode: PropTypes.string,
};

export default sizeMe()(ReadAll);
